// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"image"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 21H20L9 10L3 16V21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","cx":15.75,"cy":8.25,"r":2,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 16V3H21V21H20M3 16V21H20M3 16L9 10L20 21","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","cx":15.75,"cy":8.25,"r":2,"stroke":"currentColor","stroke-width":2},"nodeName":"circle","children":[]}]}]};

@tag('t-icon-image')
export default class ImageIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image',
    }
  }
}
